/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { TSelectedView } from '../';

import type { IResourceName } from 'volta/models/base-model';
import type { TTaskType, UTask } from 'volta/models/types/tasks';
import type EventStreamService from 'volta/services/event-stream';

interface TasksKitListSignature {
  Args: {
    resourceName?: IResourceName;
    entityResourceName?: IResourceName;
    tasks: Record<string, UTask[]>;
    selectedTask?: UTask;
    taskType?: TTaskType;
    showTaskType?: boolean;
    isAutoResolvable?: boolean;
    isLoading?: boolean;
    disabled?: boolean;
    newDisabled?: boolean;
    hideAddButton?: boolean;
    tasksReadonly?: boolean;
    dueDateIdPrefix?: string;
    taskWrapperClass?: string;
    selectedView?: TSelectedView;
    authorizedUsers?: string[];
    onSubmit?: (task: UTask) => void;
    onDelete?: (task: UTask) => void;
    onResolve?: (task: UTask) => void;
    onSelect?: (task: UTask) => void;
    onDraft?: (task: UTask) => void;
  };
  Blocks: {
    default: [unknown, unknown, unknown];
    taskGroupHeader: [unknown, unknown];
  };
  Element: HTMLDivElement;
}

export default class TasksKitListComponent extends Component<TasksKitListSignature> {
  @service eventStream!: EventStreamService;

  get tasks() {
    return Object.entries(this.args.tasks).map(([groupId, value]) => {
      return {
        groupId,
        tasks: value
      };
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::List': typeof TasksKitListComponent;
    'tasks-kit/list': typeof TasksKitListComponent;
  }
}
